import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'

import {
  TrackShipmentLink,
  DropOffPointMapLink,
  PickUpParcelLink,
} from '@marketplace-web/conversation-shipping/conversation-shipping-feature'
import { BuyerDetailsLink } from '@marketplace-web/messaging/conversation-user-feature'
import {
  ItemVerificationInfoLink,
  ElectronicsVerificationInfoLink,
} from '@marketplace-web/escrow-pricing/escrow-pricing-feature'

type Props = {
  action: string
}

const LinkAction = ({ action }: Props) => {
  switch (action) {
    case ConversationLinkActions.ShipmentTrackingLink:
      return <TrackShipmentLink />
    case ConversationLinkActions.BuyerDetailsLink:
      return <BuyerDetailsLink />
    case ConversationLinkActions.OfflineVerificationInfoLink:
      return <ItemVerificationInfoLink />
    case ConversationLinkActions.DropOffPointMapLink:
      return <DropOffPointMapLink />
    case ConversationLinkActions.ReactElectronicsVerificationInfoLink:
      return <ElectronicsVerificationInfoLink />
    case ConversationLinkActions.PickUpParcelLink:
      return <PickUpParcelLink />
    default:
      return null
  }
}

export default LinkAction
